/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { FetchThirdPartyConnectorsResponse } from '@jira/issue__third-party-connected-data-sources/src/FetchThirdPartyConnectorsResponse.types.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';

export const thirdPartyConnectedDataSourceResource: RouteResource<FetchThirdPartyConnectorsResponse> =
	createResource<FetchThirdPartyConnectorsResponse>({
		type: 'ISSUE_VIEW_THIRD_PARTY_CONNECTORS',
		getKey: ({ match }) => match.params.projectKey || '',
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-issue-view-third-party-connected-data-source", jiraSpaEntry: "async-resource-issue-view-third-party-connected-data-source" */ '@jira/issue__third-party-connected-data-sources/src/fetchThirdPartyConnectors.tsx'
			),
		maxAge: Infinity,
		isBrowserOnly: true,
	});
